/* eslint key-spacing: ["error", { "mode": "minimum" }] */

export const colors = {
  light:   '#fff',

  primary:   '#00818A',
  primaryDk:   '#00666B',

  alt: '#FAB750',
  altLt: '#FAC746'
}
